
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiDialog extends Serenity.EntityDialog<ApiRow, any> {
        protected getFormKey() { return ApiForm.formKey; }
        protected getIdProperty() { return ApiRow.idProperty; }
        protected getLocalTextPrefix() { return ApiRow.localTextPrefix; }
        protected getNameProperty() { return ApiRow.nameProperty; }
        protected getService() { return ApiService.baseUrl; }
        protected getDeletePermission() { return ApiRow.deletePermission; }
        protected getInsertPermission() { return ApiRow.insertPermission; }
        protected getUpdatePermission() { return ApiRow.updatePermission; }

        protected form = new ApiForm(this.idPrefix);

    }
}